import { useSelector } from "react-redux";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { deleteConcreteBaseOutput, requestDeletingOutput, selectState } from "../outputSlice";
import { FormatDateShort } from "utils/dateUtils";

const DeleteOutputModal = () => {
  const { outputToDelete } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(requestDeletingOutput(undefined));
  };

  const doDelete = async () => {
    try {
      if (outputToDelete !== undefined) {
        await dispatch(deleteConcreteBaseOutput(outputToDelete.outputId));
        toast.success("Uspesno obrisan.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={outputToDelete !== undefined}
      title="Poništavanje izlaza"
    >
      <p className="info-msg">
        {outputToDelete && `Da li ste sigurni da želite da poništite izlaz i sve proizvode vezane za njega (magacin: ${outputToDelete.repository.name}, br otpremnice: ${outputToDelete.billOfLandingId}, datum: ${FormatDateShort(outputToDelete.dateOfOutput)})?`}
      </p>
    </Modal>
  );
};

export default DeleteOutputModal;
